(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-dialog-loading", [], factory);
	else if(typeof exports === 'object')
		exports["vue-dialog-loading"] = factory();
	else
		root["vue-dialog-loading"] = factory();
})(window, function() {
return 